import React from "react";
import OrganicHeader from "../../../components/Compliance Certificates/orgnic/OrganicHeader";
import OrganicInfoContainer from "../../../components/Compliance Certificates/orgnic/OrganicInfoContainer";

const Organic = () => {
  return (
    <div>
      <OrganicHeader />
      <OrganicInfoContainer />
    </div>
  );
};

export default Organic;
